import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';
import { I18nText } from '@welldev-group/react-comp-lib';
import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';

import PdfStyles from '../PdfDocuments/PdfStyles';
import InvoicePdfDocument from '../PdfDocuments/InvoicePdfDocument';

const InvoicePDF = ({ invoiceId }) => {
  const [pdf, setPdf] = useState(null);

  const styles = StyleSheet.create(PdfStyles);

  const makePdf = data => {
    const { pdfDetails } = data;
    setPdf(
      <PDFDownloadLink
        document={<InvoicePdfDocument pdfDetails={pdfDetails} />}
        fileName={`${pdfDetails.title}.pdf`}
      >
        <span style={styles.linkContent}>
          <I18nText id="billing.transactions.list.label.download_pdf" />
        </span>
      </PDFDownloadLink>,
    );
  };

  const fetchPdfDetails = async id => {
    const { data } = await httpClient.get(routes.billing.invoices.pdf_details({ id }));
    makePdf(data);
  };

  useEffect(() => {
    fetchPdfDetails(invoiceId);
  }, [invoiceId]);

  return pdf;
};

InvoicePDF.propTypes = {
  invoiceId: PropTypes.number.isRequired,
};

export default InvoicePDF;
